import React from 'react';

import Alert from '@/assets/icons/Alert';

export const FormErrorNotification = ({ errorMessage }) => {
  return errorMessage ? (
    <div style={{ display: 'flex', marginTop: '-8px', fontSize: 'xs' }}>
      <Alert width='18px' height='18px' fill='var(--tractie-color-content-error)' aria-hidden='true' />
      <span style={{ color: 'var(--tractie-color-content-error)' }}>{errorMessage}</span>
    </div>
  ) : null;
};
